export default __webpack_public_path__ + "static/media/logo_juego_responsable_13.aca20811.png";